import Vue from 'vue'
import VueRouter from 'vue-router'
import Store from '../store';

Vue.use(VueRouter)

  const routes = [
    {
      path: '/',
      name: 'Home',
      component: () => import('../components/layouts/Auth'),
      meta: {
        requiresAuth: false
      },
      children: [
        {
          path: '',
          name: 'login',
          component: () => import('../views/auth/Login'),
          meta: {
            requiresAuth: false
          },
          beforeEnter: (to, from, next) => {
            if (Store.state.login) {
              next('/desc');
              window.console.log('Go to tickets');
            } else {
              next();
            }
          }
        },
      ]
    },
    {
      path: '/desc',
      component: () => import('../components/layouts/Private'),
      meta: {
        requiresAuth: true
      },
      children: [
        {
          path: '',
          name: 'actual',
          component: () => import('../views/desk/Actual'),
        },
        {
          path: 'personal',
          name: 'personal',
          component: () => import('../views/desk/Personal'),
        },
        {
          path: 'archive',
          name: 'archive',
          component: () => import('../views/desk/Archive'),
        },
        {
          path: 'create',
          name: 'create',
          component: () => import('../views/desk/Create'),
        },
        {
          path: 'ticket/:id',
          name: 'ticket',
          component: () => import('../views/desk/Ticket'),
        },
        {
          path: 'search',
          name: 'search',
          component: () => import('../views/desk/Search'),
        },
      ]
    },
    {
      path: '/account',
      component: () => import('../components/layouts/Private'),
      meta: {
        requiresAuth: true
      },
      children: [
        {
          path: 'password',
          name: 'account_password',
          component: () => import('../views/account/Password'),
        },
        {
          path: 'report',
          name: 'account_report',
          component: () => import('../views/account/Report'),
        },
      ]
    },
    {
      path: '/help',
      component: () => import('../components/layouts/Private'),
      meta: {
        requiresAuth: true
      },
      children: [
        {
          path: 'list',
          name: 'posts',
          component: () => import('../views/help/List'),
        },
        {
          path: 'post/:id',
          name: 'post',
          component: () => import('../views/help/Detail'),
        },
      ]
    },
    {
      path: '/kanban',
      component: () => import('../components/layouts/Private'),
      meta: {
        requiresAuth: true
      },
      children: [
        {
          path: 'list',
          name: 'boards',
          component: () => import('../views/kanban/Boards'),
        },
        {
          path: 'detail/:id',
          name: 'stages',
          component: () => import('../views/kanban/Board'),
        },
      ]
    },
    {
      path: '/chats',
      component: () => import('../components/layouts/Private'),
      meta: {
        requiresAuth: true
      },
      children: [
        {
          path: 'list',
          name: 'chats',
          component: () => import('../views/chats/Chats'),
        },
        {
          path: 'detail/id',
          name: 'chatDetail',
          component: () => import('../views/chats/ChatDetail'),
        },
      ]
    }
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(route => route.meta.requiresAuth)) {
    if (Store.state.login) {
      window.console.log('Access allowed');
      next();
    } else {
      next('/');
      window.console.log('Access denied');
    }
  } else {
    next();
  }
});

export default router
